import { getAccount, logout } from '../Auth/AuthProvider';
import { getProfile } from '../Auth/GraphService';

class UserHelper {
  GetInitialsFromId = (userId: string) => {
    const names = this.getNameFromId(userId).split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };

  getNameFromId = (userId: string) => {
    const splits = userId.split('@');
    const name = splits[0].replace('.', ' ');
    return name;
  };

  getUserName = () => {
    const userInfo = getAccount();
    if (!userInfo) return '';

    return this.getNameFromId(userInfo.username);
  };

  getUserProfile = async (): Promise<Blob> => {
    const profile = await getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    return profile;
  };

  logOut = (): void => {
    logout();
  };

  getUser = () => {
    const account = getAccount();

    if (!account) return null;

    return {
      name: account.name ?? account.username,
      username: account.username,
    };
  };

  getUserInitials = () => {
    const userInfo = getAccount();
    if (!userInfo) return '';

    return this.GetInitialsFromId(userInfo.username);
  };
}

const userHelper: UserHelper = new UserHelper();
export default userHelper;
